const ViewConsignmentsLegs=(props)=>{
    const handleClick = (params) => {
        props.onClickShowConsignmentsLegsData(props);
    };
    return (
        <a onClick={handleClick} title="View Consignment Legs"><i className="fa fa-sitemap f20"></i></a>
    );
}
export default ViewConsignmentsLegs